export const AddressType = [
  {
    key: "HOME",
    value: 1,
  },
  {
    key: "WORK",
    value: 2,
  },
  {
    key: "OTHER",
    value: 3,
  },
];

export const AddressTypeMap = {
  1: "homeAddress",
  2: "workAddress",
  3: "otherAddress",
};
